<div id="transactional-data-page">
  <div class="col-lg-8 col-md-5 col-sm-0 col-xs-12 p0 flumainsecHt" id="Transactional-details">
    <p class="prodCat-title">Transactional Data</p>
  </div>
  <div class="col-lg-12 col-md-12 p0 links">
    <div class="col-lg-7 col-md-4 not-mobile-view"></div>
    <div class="
        col-lg-5
        save-document
        flu-confirmation
        save-document-container
        links-section
        mb1
        mt0
      " data-html2canvas-ignore="true">
      <a (click)="goToPaymentHistory()" title="Back to dashboard"><img
          src="../../../assets/icons/{{baseSiteId}}/chevron-left_green.svg" alt="" class="chevron-left" />
        Back to payment history</a>
      <a href="javascript:void(0)" target="" aria-label="download as" id="tealium-xls" data-di-id="#tealium-xls"
        (click)="exportXls()" class="xls_fluOverview xls_cart xls-cart-img-section"><img
          src="../../../assets/icons/{{baseSiteId}}/excel_new.png" alt="" />XLS</a>
      <a (click)="generatePDF()" href="javascript:void(0)" target="" title="pdf" id="view_trans_data_pdf"
        data-di-id="#view_trans_data_pdf"><img src="../../../assets/icons/{{baseSiteId}}/pdf.png" alt="PDF" /> PDF</a>
      <a href="javascript:void(0)" target="" aria-label="download as" onclick="window.print();"><img
          src="../../../assets/icons/{{baseSiteId}}/print.svg" alt="" class="print-icon" /> Print</a>
    </div>
  </div>
  <div class="account-section" id="account-section">
    <!-- The div is commented as the account section layout is getting overlapped for account history page and invoice page -->
    <!-- <div class="row row-20 checkout" id="leftCont-rightNav">  -->
    <div class="yCmsContentSlot account-section-content">
      <div class="row row-20 transactional" id="">
        <section class="col-md-12 col-sm-12 col-xs-12 order-history-right float-right">
          <div id="product-listing">
            <div class="prodList-box">
              <div id="dummy-overlay"></div>
              <div class="order-history-table">
                <!--table starts-->
                <div class="row">
                  <div class="col-md-12 tablemain-padding">
                    <div class="locationIcon">
                      <img src="../../../assets/icons/{{baseSiteId}}/location.svg" class="" />
                      <h4 id="location" *ngIf="paymentHistoryDetails.length > 0">
                        {{ paymentHistoryDetails[0]?.location }} ({{
                        paymentHistoryDetails[0]?.accountNumber
                        }})
                      </h4>
                    </div>

                    <div id="transactional-details-table" class="dataTables_wrapper no-footer not-mobile-view">
                      <table id="example1" class="display transactional_data dataTable no-footer" style="width: 100%"
                        role="grid" aria-describedby="example1_info">
                        <thead>
                          <tr class="heading" role="row">
                            <th class="date-new sorting_disabled" rowspan="1" colspan="1" style="width: 96px">
                              Due date
                            </th>
                            <th class="date-new sorting_disabled" rowspan="1" colspan="1" style="width: 97px">
                              Date paid
                            </th>
                            <th class="invoice sorting_disabled" rowspan="1" colspan="1" style="width: 89px">
                              Invoice#
                            </th>
                            <th class="po sorting_disabled" rowspan="1" colspan="1" style="width: 105px">
                              PO #
                            </th>
                            <th class="invoice-amount sorting_disabled" rowspan="1" colspan="1" style="width: 139px">
                              Invoice amount
                            </th>
                            <th class="discount sorting_disabled" rowspan="1" colspan="1" style="width: 181px">
                              Prompt pay discount
                            </th>
                            <th class="sorting_disabled" rowspan="1" colspan="1" style="width: 114px">
                              Amount paid
                            </th>
                            <th class="sorting_disabled" rowspan="1" colspan="1" style="width: 149px">
                              Payment method
                            </th>
                            <th class="sorting_disabled" rowspan="1" colspan="1" style="width: 142px">
                              Invoice balance
                            </th>
                          </tr>
                        </thead>
                        <tbody class="datatable-row">
                          <tr class="row_bold odd" role="row" *ngFor="let data of transactionalDetails">
                            <td>{{ data?.dueDate }}</td>
                            <td>{{ data?.paymentDate }}</td>

                            <td headers="table1col3" class="darkblue">
                              <span *ngIf="asmStringCheck(data?.invoiceNo); else notAsmUser">
                                {{data?.invoiceNo}}</span>
                              <ng-template #notAsmUser>
                                <a (click)="pdfOpen(data)">{{data?.invoiceNo}}</a>
                              </ng-template>
                            </td>
                            <td>{{ data?.poNo }}</td>
                            <td class="text-right">
                              <span *ngIf="data.indicator === 'H' && data.type === 'legacy'">(</span><span>${{
                                data.invoiceAmount }}</span><span
                                *ngIf="data.indicator === 'H' && data.type === 'legacy'">)</span>
                            </td>
                            <td class="text-right">
                              ${{ data?.discountAmount }}
                            </td>
                            <td class="text-right">
                              <span *ngIf="data.indicator === 'H' && data.type === 'legacy'">(</span><span>${{
                                data.plannedAmount }}</span><span
                                *ngIf="data.indicator === 'H' && data.type === 'legacy'">)</span>
                            </td>
                            <td class="imgtxt" *ngIf="data.type === 'recent'">
                              <img src="../../../assets/icons/check.svg" alt="check"
                                *ngIf="data.paymentMethod === 'Checking Account'" />
                              <img src="../../../assets/img/ccVISA.png" alt="visa" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Card' &&
                                  data.cardType &&
                                  data?.cardType.toUpperCase() === 'VISA'
                                " />
                              <img src="../../../assets/img/ccMC.png" alt="mc" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Card' &&
                                  data.cardType &&
                                  data?.cardType.toUpperCase() === 'MC'
                                " />
                              <img src="../../../assets/img/ccDISC.png" alt="disc" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Card' &&
                                  data.cardType &&
                                  data?.cardType.toUpperCase() === 'DISC'
                                " />
                              <img src="../../../assets/img/amex.png" alt="amex" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Card' &&
                                  data.cardType &&
                                  data?.cardType.toUpperCase() === 'AMEX'
                                " />
                              <div class="payment-text">
                                <ng-container *ngIf="
                                    data.paymentMethod !== 'Credit Card' &&
                                    data.paymentMethod !== 'Checking Account'
                                  ">
                                  {{ data.paymentMethod }}
                                </ng-container>
                                <ng-container *ngIf="
                                    data.paymentMethod === 'Electronic Wire' ||
                                    data.paymentMethod === 'Pay by credit' ||
                                    data.paymentMethod === 'Checking Account' ||
                                    data.paymentMethod === 'Credit' ||
                                    data.paymentMethod === 'Check'
                                  "><span *ngIf="
                                      data.paymentMethod === 'Checking Account'
                                    ">#</span>
                                  <!-- <span>{{
                                    data.clearDocRef
                                    }}</span> -->
                                  <ng-container
                                    *ngFor="let refNo of data.clearDocRef?.split(',') | slice:0:5;let i = index; let c= count">
                                    <p class="m-0 d-flex">{{refNo}}<span *ngIf="i !== c - 1">,</span></p>
                                  </ng-container>
                                </ng-container>
                                <ng-container *ngIf="
                                    data.paymentMethod === 'Credit Card' ||
                                    data.paymentMethod === 'Electronic Checks'
                                  ">
                                  <span *ngIf="data.paymentMethod === 'Credit Card'">#</span>
                                  <span>{{ data.ccNum }}</span>
                                </ng-container>
                              </div>
                            </td>
                            <td class="imgtxt" *ngIf="data.type === 'legacy'">
                              <img src="../../../assets/icons/check.svg" alt="check" *ngIf="
                                  data.paymentMethod === 'Checks' ||
                                  data.paymentMethod === 'Electronic Checks'
                                " />
                              <img src="../../../assets/img/ccVISA.png" alt="visa" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Cards' &&
                                  data.cardType === 'VISA'
                                " />
                              <img src="../../../assets/img/ccMC.png" alt="mc" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Cards' &&
                                  data.cardType === 'MC'
                                " />
                              <img src="../../../assets/img/ccDISC.png" alt="disc" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Cards' &&
                                  data.cardType === 'DISC'
                                " />
                              <img src="../../../assets/img/amex.png" alt="amex" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Cards' &&
                                  data.cardType === 'AMEX'
                                " />
                              <div class="payment-text">
                                <ng-container *ngIf="
                                    data.paymentMethod !== 'Credit Cards' &&
                                    data.paymentMethod !== 'Checks' &&
                                    data.paymentMethod !== 'Electronic Checks'
                                  ">
                                  {{ data.paymentMethod }}
                                </ng-container>
                                <ng-container *ngIf="data.paymentMethod === 'Checks'">
                                  #{{ data.checkNumber }}</ng-container>
                                <ng-container *ngIf="
                                    data.paymentMethod === 'Credit Cards' ||
                                    data.paymentMethod === 'Electronic Checks'
                                  ">#{{ data.ccNum }}
                                </ng-container>
                                <ng-container *ngIf="data.paymentMethod === 'Credit Memo'">#{{ data.creditMemoNumber }}
                                </ng-container>
                              </div>
                            </td>

                            <td class="text-right">
                              <span *ngIf="data.indicator === 'H' && data.type === 'legacy'">(</span><span>${{
                                data.invoiceBalance }}</span><span
                                *ngIf="data.indicator === 'H' && data.type === 'legacy'">)</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!--MOBILE VIEW STARTS-->

                    <section class="orders-table-orders mobile-view">
                      <div class="orders-row-table" *ngFor="let data of transactionalDetails; let i = index">
                        <div class="column header-column orders-table-col">
                          <section class="col-header-rwd">
                            <p>
                              <b>Due date &nbsp;</b>
                            </p>
                            <p>
                              <b> Date paid # &nbsp; </b>
                            </p>
                            <p>
                              <b> Invoice# &nbsp; </b>
                            </p>
                            <p>
                              <b> PO # &nbsp; </b>
                            </p>
                            <p>
                              <b> Invoice amount # &nbsp; </b>
                            </p>

                            <p>
                              <b> Prompt pay discount &nbsp; </b>
                            </p>
                            <p>
                              <b> Amount paid &nbsp; </b>
                            </p>
                            <p>
                              <b> Payment method &nbsp; </b>
                            </p>
                            <p>
                              <b> Invoice balance &nbsp; </b>
                            </p>
                          </section>
                        </div>
                        <div class="column desc-column">
                          <section>
                            <p>
                              {{ data?.dueDate }}
                            </p>
                            <p>{{ data?.paymentDate }}</p>
                            <p>
                              <span *ngIf="asmStringCheck(data?.invoiceNo); else notAsmUser">
                                {{data?.invoiceNo}}</span>
                              <ng-template #notAsmUser>
                                <a (click)="pdfOpen(data)">{{data?.invoiceNo}}</a>
                              </ng-template>
                            </p>
                            <p>{{ data?.poNo }}</p>
                            <p>
                              <span *ngIf="data.indicator === 'H' && data.type === 'legacy'">(</span><span>${{
                                data.invoiceAmount }}</span><span
                                *ngIf="data.indicator === 'H' && data.type === 'legacy'">)</span>
                            </p>
                            <p>${{ data?.discountAmount }}</p>
                            <p>
                              <span *ngIf="data.indicator === 'H' && data.type === 'legacy'">(</span><span>${{
                                data.plannedAmount }}</span><span
                                *ngIf="data.indicator === 'H' && data.type === 'legacy'">)</span>
                            </p>
                            <div *ngIf="data.type === 'recent'">
                              <img src="../../../assets/icons/check.svg" alt="check"
                                *ngIf="data.paymentMethod === 'Checking Account'" />
                              <img src="../../../assets/img/ccVISA.png" alt="visa" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Card' &&
                                  data.cardType === 'VISA'
                                " />
                              <img src="../../../assets/img/ccMC.png" alt="mc" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Card' &&
                                  data.cardType === 'MC'
                                " />
                              <img src="../../../assets/img/ccDISC.png" alt="disc" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Card' &&
                                  data.cardType === 'DISC'
                                " />
                              <img src="../../../assets/img/amex.png" alt="amex" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Card' &&
                                  data.cardType === 'AMEX'
                                " />
                              <p *ngIf="
                                  data.paymentMethod !== 'Credit Card' &&
                                  data.paymentMethod !== 'Checking Account'
                                ">
                                {{ data.paymentMethod }}
                              </p>
                              <p *ngIf="
                                  data.paymentMethod === 'Electronic Wire' ||
                                  data.paymentMethod === 'Pay by credit' ||
                                  data.paymentMethod === 'Checking Account' ||
                                  data.paymentMethod === 'Credit' ||
                                  data.paymentMethod === 'Check'
                                ">
                                <ng-container *ngIf="
                                    data.paymentMethod === 'Checking Account'
                                  ">#</ng-container>
                                <!-- {{ data.clearDocRef }} -->
                                <ng-container
                                  *ngFor="let refNo of data.clearDocRef?.split(',') | slice:0:5;let i = index; let c= count">
                                  <p class="m-0 d-flex">{{refNo}}<span *ngIf="i !== c - 1">,</span></p>
                                </ng-container>
                              </p>
                              <p *ngIf="
                                  data.paymentMethod === 'Credit Card' ||
                                  data.paymentMethod === 'Electronic Checks'
                                ">
                                <ng-container *ngIf="data.paymentMethod === 'Credit Card'">#</ng-container>
                                {{ data.ccNum }}
                              </p>
                            </div>
                            <div *ngIf="data.type === 'legacy'">
                              <img src="../../../assets/icons/check.svg" alt="check" *ngIf="
                                  data.paymentMethod === 'Checks' ||
                                  data.paymentMethod === 'Electronic Checks'
                                " />
                              <img src="../../../assets/img/ccVISA.png" alt="visa" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Cards' &&
                                  data.cardType === 'VISA'
                                " />
                              <img src="../../../assets/img/ccMC.png" alt="mc" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Cards' &&
                                  data.cardType === 'MC'
                                " />
                              <img src="../../../assets/img/ccDISC.png" alt="disc" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Cards' &&
                                  data.cardType === 'DISC'
                                " />
                              <img src="../../../assets/img/amex.png" alt="amex" class="visa-card" *ngIf="
                                  data.paymentMethod === 'Credit Cards' &&
                                  data.cardType === 'AMEX'
                                " />
                              <p *ngIf="
                                  data.paymentMethod !== 'Credit Cards' &&
                                  data.paymentMethod !== 'Checks' &&
                                  data.paymentMethod !== 'Electronic Checks'
                                ">
                                {{ data.paymentMethod }}
                              </p>
                              <p *ngIf="data.paymentMethod === 'Checks'">
                                #{{ data.checkNumber }}
                              </p>
                              <p *ngIf="
                                  data.paymentMethod === 'Credit Cards' ||
                                  data.paymentMethod === 'Electronic Checks'
                                ">
                                #{{ data.ccNum }}
                              </p>
                              <p *ngIf="data.paymentMethod === 'Credit Memo'">
                                #{{ data.creditMemoNumber }}
                              </p>
                            </div>
                            <p>
                              <span *ngIf="data.indicator === 'H' && data.type === 'legacy'">(</span><span>${{
                                data.invoiceBalance }}</span><span
                                *ngIf="data.indicator === 'H' && data.type === 'legacy'">)</span>
                            </p>
                          </section>
                        </div>
                      </div>
                    </section>

                    <!--MOBILE VIEW ENDS-->
                  </div>
                </div>
                <!--table ends-->
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!--  </div> -->
  </div>
</div>